import { FC } from 'react'
import { FiCheck } from 'react-icons/fi'
import CustomText from '../../CustomText'

type StepperPillProps = {
  label: string
  count: string
  isActive: boolean
  handleClick: () => void
  disableButton: boolean
  passedStepper?: boolean
}

export const StepperPill: FC<StepperPillProps> = ({
  label,
  count,
  isActive,
  handleClick,
  disableButton = false,
  passedStepper = false
}: StepperPillProps) => {
  return (
    <div className={`w-auto h-auto flex flex-col items-center gap-y-4`} onClick={handleClick}>
      <div
        className={`w-[52px] h-[52px] flex flex-row justify-center items-center rounded-full ${isActive ? 'bg-[#ffbe00]' : ''} ${passedStepper ? 'bg-[#5cbdeb]' : ''} ${!passedStepper && !isActive ? 'bg-[#ffffff] border-solid border-[1.5px] border-[#cdcdcd]' : ''}`}
      >
        {!isActive && !passedStepper && (
          <CustomText
            textLabel={count}
            fontWeight={`font-regular`}
            fontSize="text-[20px]"
            fontColor={`text-black`}
          />
        )}

        {isActive && !passedStepper && (
          <CustomText
            textLabel={count}
            fontWeight={`font-regular`}
            fontSize="text-[20px]"
            fontColor={`text-black`}
          />
        )}

        {!isActive && passedStepper && (
          <FiCheck className="w-[24px] h-[24px] tSM2:w-[16px] tSM2:h-[16px] mMD:w-[14px] mMD:h-[14px]" />
        )}
      </div>

      <CustomText
        textLabel={label}
        fontWeight={`font-regular`}
        fontSize="text-[16px]"
        fontColor={`text-black`}
      />
    </div>
  )
}

export default StepperPill
